import Controller from "./localeEditableField.controller";
import template from "./localeEditableField.html";

const localeEditableField = {
  template,
  controller: Controller,
  bindings: {
    languages: "<",
    i18n: "=",
    title: "@",
    type: "@",
    fill: "@",
    eventName: "<",
    name: "@",
    showRemove: "@",
    isRequired: "<",
    isConditional: "@",
    hideEdit: "<",
    permissionName: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    extraParams: "<",
    currentCity: "<",
    updateCityEvent: "<",
    isDependCurrentCityOnly: "<",
  },
};

export default localeEditableField;



// WEBPACK FOOTER //
// ./src/components/localeEditableField/localeEditableField.component.js